import { useContext } from 'react'
import { ModalContext } from './ModalContext'

/**
 * Composant d'en-tête pour le Modal
 * 
 * @param {Object} props - Les props du composant
 * @param {ReactNode} props.children - Contenu de l'en-tête
 * @param {string} props.className - Classes additionnelles
 * @param {boolean} props.showCloseButton - Afficher le bouton de fermeture (optionnel, par défaut: true)
 * @returns {JSX.Element} Le composant ModalHeader
 */
const ModalHeader = ({
  children,
  className = '',
  showCloseButton = true
}) => {
  const { onClose } = useContext(ModalContext)

  return (
    <div className={`${className}`}>
      {/* Titre */}
      {children && children.length > 0 && (
        <h3 className="font-bold text-lg">
          {children}
        </h3>
      )}
      
      {/* Bouton de fermeture */}
      {showCloseButton && (
        <form method="dialog">
          <button 
            className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
            onClick={onClose}
            aria-label="Fermer"
          >
            ✕
          </button>
        </form>
      )}
    </div>
  )
}

// ModalHeader.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
//   showCloseButton: PropTypes.bool
// }

export default ModalHeader